import { render, staticRenderFns } from "./injuryHistory.vue?vue&type=template&id=d3a58c52&scoped=true"
import script from "./injuryHistory.vue?vue&type=script&lang=js"
export * from "./injuryHistory.vue?vue&type=script&lang=js"
import style0 from "./injuryHistory.vue?vue&type=style&index=0&id=d3a58c52&prod&scoped=true&lang=css"
import style1 from "./injuryHistory.vue?vue&type=style&index=1&id=d3a58c52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a58c52",
  null
  
)

export default component.exports